import HttpClient from '../../HttpClient/NewApi';
import {concatAll, map, toArray} from "rxjs/operators";
import {of} from "rxjs";

export default {
    getAll() {
        return HttpClient
            .get(`/api/v1/sales-orders`)
            .pipe(
                concatAll(response => of(response)),
                map(salesOrder => new SalesOrder(
                    salesOrder.id,
                    salesOrder.price,
                    salesOrder.volume,
                    salesOrder.address,
                    salesOrder.status,
                    salesOrder.quality,
                    salesOrder.createdAt,
                    salesOrder.overdueAt,
                    salesOrder.volumeId,
                    salesOrder.willBeExpiredSoon,
                    new Culture(
                        salesOrder.culture.id,
                        salesOrder.culture.name,
                    ),
                    salesOrder.supplier ?
                        new Supplier(
                            salesOrder.supplier.id,
                            salesOrder.supplier.name,
                        ) : null
                )),
                toArray(),
            )
    }
}

const NEW = 'new';
const WAIT_IN_PROGRESS = 'waitInProgress';
const IN_PROGRESS = 'inProgress';
const COMPLETED = 'completed';
const CANCELLED = 'canceled';

class SalesOrder
{
    constructor(
        id,
        price,
        volume,
        address,
        status,
        quality,
        createdAt,
        overdueAt,
        volumeId,
        willBeExpiredSoon,
        culture,
        supplier,
    ) {
        this.id = id;
        this.price = price;
        this.volume = volume;
        this.address = address;
        this.status = status;
        this.quality = quality;
        this.createdAt = createdAt;
        this.overdueAt = overdueAt;
        this.volumeId = volumeId;
        this.willBeExpiredSoon = willBeExpiredSoon;
        this.culture = culture;
        this.supplier = supplier;
    }

    canBeCancelled()
    {
        return this.isActive();
    }

    isActive()
    {
        return [
            NEW,
            IN_PROGRESS,
            WAIT_IN_PROGRESS
        ].includes(this.status)
    }

    getReadableStatus()
    {
        const statuses = {
            new : "Новая",
            waitInProgress: 'Ожидает подтверждения',
            inProgress: 'В работе',
            completed: 'завершена',
            canceled: 'отменена'
        }

        return statuses[this.status]
    }

    isNew()
    {
        return this.status === NEW;
    }

    isWaitingInProgress()
    {
        return this.status === WAIT_IN_PROGRESS;
    }

    isInProgress()
    {
        return this.status === IN_PROGRESS;
    }

    isCompleted()
    {
        return this.status === COMPLETED;
    }

    isCancelled()
    {
        return this.status === CANCELLED;
    }
}

class Supplier {
    constructor(
        id,
        name,
    ) {
        this.id = id;
        this.name = name;
    }
}

class Culture {
    constructor(
        id,
        name,
    ) {
        this.id = id;
        this.name = name;
    }
}


// WEBPACK FOOTER //
// ./apiClient/SalesOrder/GetList/index.js